import { createAsyncReducer } from '@telstra-connect/standard-actions';
import {
    ILoadCidnAction,
    ILoadCidnSuccessAction,
    LoadCidnErrorAction,
} from '../actions/load-cidn';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadCidnAction
    = ILoadCidnAction
    | ILoadCidnSuccessAction
    | LoadCidnErrorAction;

const init = (state: IBillingState, action: LoadCidnAction) => ({
    ...state,
    cidnList: {
        ...state.cidnList,
        status: action.status
    }
});

const success = (state: IBillingState, action: LoadCidnAction) => ({
    ...state,
    cidnList: {
        status: action.status,
        data: (action as ILoadCidnSuccessAction).data.cidnList
    },
});

const failure = (state: IBillingState, action: LoadCidnAction) => ({
    ...state,
    cidnList: {
        ...initialState.cidnList,
        status: action.status,
        error: (action as LoadCidnErrorAction).error,
        errorCode: (action as LoadCidnErrorAction).errorCode
    }
});

export const loadCidnReducer = createAsyncReducer(initialState, init, success, failure);
